import { formatDate, sanitizeForCSV } from 'src/utils/misc';
import Papa from 'papaparse';
import { EventsQuery } from 'src/graphql/_generated';
import { getEventCompletionStatusLabel } from 'src/api/types';
import { EventCsvHeaders } from 'src/api/types/misc';

type DownloadCsv = (params: { data: EventsQuery['events']; name: string }) => void;
export const downloadCsv: DownloadCsv = ({ data, name }) => {
  const rows = [
    [
      EventCsvHeaders.ID,
      EventCsvHeaders.Owner,
      EventCsvHeaders.Title,
      EventCsvHeaders.CompletionStatus,
      EventCsvHeaders.DueDate,
      EventCsvHeaders.DateCompleted,
      EventCsvHeaders.CompletedBy,
      EventCsvHeaders.Created,
    ],
    ...data.map((el) => {
      return [
        sanitizeForCSV(el.id),
        sanitizeForCSV(el.assignedTo?.text || el.assignedTo?.email),
        sanitizeForCSV(el.notes),
        getEventCompletionStatusLabel(el.completionStatus),
        formatDate(el.dueDate),
        formatDate(el.completedAt),
        sanitizeForCSV(el.completedBy?.text || el.completedBy?.email),
        formatDate(el.meta?.createdAt, { formatType: 'datetime' }),
      ];
    }),
  ];

  const csvString = Papa.unparse(rows, { delimiter: ';' });
  const anchor = document.createElement('a');
  anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(csvString);
  anchor.target = '_blank';
  anchor.download = `${name} - Actions Export.csv`;
  anchor.click();
};
